import type { Dictionary } from '../types'

export const tr: Dictionary = {
  siteContents: {
    title: 'Site İçerikleri',
    description: 'Menüler, yasal sayfalar, UI metinleri, KVKK/çerez ve SEO ayarları tek panelden yönetilir.',
    tabs: {
      header: 'Header Menü',
      footer: 'Footer',
      legal: 'Yasal Sayfalar',
      faq: 'SSS / FAQ',
      contents: 'Özel İçerikler',
      ui: 'UI Çevirileri',
      kvkk: 'KVKK / Çerez',
      seo: 'SEO & Analitik',
    },
    header: {
      title: 'Üst Menü (Header)',
      description: 'Ana navigasyon linkleri ve dropdown menüler',
    },
    footer: {
      title: 'Footer Menü',
      description: 'Her sütun vitrinde bir başlık altında link listesi olarak görünür. Tablo ile tek tek, JSON ile toplu AI çevirisi.',
      columnPrefix: '[Sütun]',
      addColumn: 'Sütun Ekle',
      saved: 'Footer sütunu kaydedildi',
      saveFailed: 'Sütun kaydedilemedi',
      deleted: 'Sütun silindi',
      linksSaved: 'Linkler kaydedildi',
      linksSaveFailed: 'Linkler kaydedilemedi',
      structureTitle: 'Footer yapısı',
      structureStep1: 'Sütun = footer\'daki kolon başlığı (ör. Mağaza, Hesap).',
      structureStep2: 'Sütunu genişletip altına linkler ekleyin; Kaydet ile vitrine yansır.',
      structureStep3: 'Sıra alanı kolonların ve linklerin görünüm sırasını belirler.',
      structureStep4: 'Çoklu dil: sütun başlığı ve her link metni için TR/EN/DE/RU çevirileri.',
      emptyTitle: 'Henüz footer sütunu yok',
      emptyDesc: 'Mağaza, Hesap, Destek ve Yasal gibi sütunlar ekleyerek başlayın.',
      addFirst: 'İlk sütunu ekle',
      orderAndLinks: 'Sıra {order} · {count} link',
      editColumn: 'Sütunu düzenle',
      deleteColumn: 'Sütunu sil',
      deleteConfirm: '"{title}" sütunu ve tüm linkleri silinsin mi?',
      columnLinks: 'Sütun linkleri',
      noLinks: 'Bu sütunda henüz link yok.',
      linkN: 'Link #{n}',
      removeLink: 'Linki kaldır',
      linkText: 'Link metni',
      saveLinks: 'Linkleri Kaydet',
      editModal: 'Footer Sütunu Düzenle',
      newModal: 'Yeni Footer Sütunu',
      columnTitle: 'Sütun başlığı *',
      columnTitlePlaceholder: 'Mağaza, Hesap, Destek…',
    },
    menus: {
      addLink: '+ Link Ekle',
      megaMenuTitle: 'Mega menü kullanımı',
      megaStep1: 'Yeni veya mevcut header linkinde Dropdown menü kutusunu işaretleyip kaydedin.',
      megaStep2: 'Tabloda ilgili satırdaki Dropdown butonuna tıklayın.',
      megaStep3: 'Bölümler ve linkler ekleyin; isteğe bağlı sağ tarafta görünecek promosyon kartına görsel ve CTA yazın.',
      megaStep4: 'Kaydettikten sonra mağaza vitrininde mega menü otomatik görünür (içerik yoksa alt linklerle klasik dropdown kullanılır).',
      emptyTitle: 'Henüz link yok',
      emptyDesc: 'Yeni bir menü linki ekleyin.',
      addEmptyLink: 'Link ekle',
      colOrder: 'Sıra',
      colTitle: 'Başlık',
      colUrl: 'URL',
      colStatus: 'Durum',
      addChild: '+ Alt',
      editModal: 'Link Düzenle',
      addChildModal: 'Alt Link Ekle',
      newModal: 'Yeni Link',
      parentLink: 'Üst Link (dropdown)',
      noParent: '— Yok (kök link) —',
      linkTitle: 'Başlık *',
      orderLabel: 'Sıra',
      dropdown: 'Dropdown menü',
      dropdownHint: 'Kaydettikten sonra listede Dropdown butonu görünür. Oradan mega menü bölümleri ve sağdaki görsel promosyon kartını düzenleyin. Sadece alt link eklemek istiyorsanız bölüm/kart boş bırakılabilir.',
      deleteConfirm: '{title} silinsin mi?',
      inlineBulkDesc: 'Tablo ile tek tek, JSON ile toplu AI çevirisi.',
    },
    legal: {
      title: 'Yasal & Statik Sayfalar',
      description: 'KVKK, gizlilik politikası, hakkımızda gibi sayfalar. Tablo ile tek tek, JSON ile toplu AI çevirisi.',
      addPage: '+ Sayfa Ekle',
      emptyTitle: 'Henüz sayfa yok',
      emptyDesc: 'Yasal veya kurumsal sayfa ekleyin.',
      addPageEmpty: 'Sayfa ekle',
      colTitle: 'Başlık',
      colSlug: 'Slug',
      colOrder: 'Sıra',
      colStatus: 'Durum',
      published: 'Yayında',
      hidden: 'Gizli',
      editModal: 'Sayfa Düzenle',
      newModal: 'Yeni Sayfa',
      contentTr: 'İçerik (Türkçe) *',
      contentOther: 'İçerik (diğer diller)',
    },
    faqTab: {
      title: 'SSS / FAQ',
      description: 'Sıkça sorulan sorular — storefront\'ta /faq. Tablo ile tek tek, JSON ile toplu AI çevirisi.',
      addQuestion: '+ Soru Ekle',
      searchPlaceholder: 'Soru ara...',
      emptyTitle: 'Henüz SSS yok',
      emptyDesc: 'İlk soruyu ekleyin.',
      addEmpty: 'Soru ekle',
      colQuestion: 'Soru',
      colOrder: 'Sıra',
      colStatus: 'Durum',
      published: 'Yayında',
      hidden: 'Gizli',
      editModal: 'SSS Düzenle',
      newModal: 'Yeni SSS',
      questionLabel: 'Soru *',
      answerTr: 'Cevap (Türkçe) *',
      answerOther: 'Cevap (diğer diller)',
    },
    contents: {
      description: 'Sayfa ve bölüm anahtarıyla özel içerik blokları. Örnek: home / hero, about / intro, contact / sidebar',
      addContent: '+ İçerik Ekle',
      searchPlaceholder: 'Sayfa veya bölüm ara…',
      emptyTitle: 'İçerik yok',
      emptyDesc: 'Yeni bir içerik bloğu ekleyin.',
      colPage: 'Sayfa',
      colSection: 'Bölüm',
      colType: 'Tip',
      colStatus: 'Durum',
      previewLink: 'Önizle',
      previewTitle: 'Mağazada görüntüle',
      active: 'Aktif',
      inactive: 'Pasif',
      saved: 'İçerik güncellendi',
      added: 'İçerik eklendi',
      deleted: 'İçerik silindi',
      saveFailed: 'Kaydedilemedi',
      deleteFailed: 'Silinemedi',
      deleteConfirm: 'Bu içerik bloğu silinsin mi?',
      editModal: 'İçeriği Düzenle',
      newModal: 'Yeni İçerik',
      pageLabel: 'Sayfa (page)',
      sectionLabel: 'Bölüm (section)',
      typeLabel: 'İçerik tipi',
      typeText: 'Metin',
      storeLocation: 'Mağaza konumu:',
    },
    ui: {
      alertInfo: 'Tablo: tek tek düzenle. JSON: dosyayı kopyala → AI\'ya ver → çevirilmiş JSON\'u yapıştır → kaydet.',
      alertFormat: 'Format:',
      alertSingleLang: '(+ hedef dil)',
      searchPlaceholder: 'Anahtar veya metin ara…',
      allGroups: 'Tüm gruplar',
      custom: 'Özel',
      saveJson: 'JSON\'u kaydet',
      savedCount: '{count} çeviri kaydedildi',
      saveFailed: 'Kayıt başarısız',
      importedCount: 'JSON içe aktarıldı: {count} kayıt',
      jsonSaveFailed: 'JSON kaydı başarısız',
      seedSuccess: 'Varsayılanlar: {inserted} eklendi, {skipped} atlandı',
      seedFailed: 'Seed başarısız',
      copyOneLang: '{lang} JSON panoya kopyalandı',
      copyAll: 'Tüm diller JSON olarak kopyalandı',
      copyFailed: 'Kopyalama başarısız',
      importEmpty: 'İçe aktarılacak kayıt yok',
      invalidJson: 'Geçersiz JSON',
      reset: 'Sıfırla',
      copyLocale: '{lang} kopyala',
      copyAllLangs: 'Tüm dilleri kopyala',
      jsonAriaLabel: 'UI çevirileri JSON',
      noTranslations: 'Çeviri bulunamadı. "Varsayılanları yükle" ile kataloğu oluşturun.',
      colKey: 'Anahtar',
      tipTitle: 'İpucu:',
      tip: 'Önce TR veya EN\'yi kopyala → AI\'ya "aynı anahtarlarla DE JSON üret" de → dönen JSON\'u buraya yapıştır → JSON\'u kaydet. Tek dil düz obje yapıştırırsan soldaki hedef dil kullanılır.',
      jsonFormatError: 'Format: { "de": { "nav.cart": "..." } } veya tek dil { "nav.cart": "..." }',
      jsonMustBeObject: 'JSON bir nesne olmalı',
    },
    seo: {
      loading: 'SEO ayarları yükleniyor…',
      loadFailed: 'SEO ayarları yüklenemedi.',
      saved: 'SEO & analitik ayarları kaydedildi.',
      saveFailed: 'Kayıt başarısız',
      saveBtn: 'Değişiklikleri kaydet',
      pillMetaDesc: 'Meta açıklama',
      pillGtm: 'GTM',
      pillMerchant: 'Merchant feed',
      pillSitemap: 'Site haritası',
      configured: 'Yapılandırıldı',
      missing: 'Eksik',
      metaTitle: 'Meta & arama görünümü',
      metaDesc2: 'Google ve diğer arama motorlarında vitrininizin nasıl listeleneceğini belirleyin.',
      metaDescLabel: 'Meta açıklama',
      metaDescLength: '{len} / 160 ·',
      metaDescNotEntered: 'Henüz girilmedi',
      metaDescIdeal: 'İdeal uzunluk',
      metaDescBitLong: 'Biraz uzun',
      metaDescTooLong: 'Çok uzun — kısaltın',
      metaDescPlaceholder: 'Mağazanızı kısa ve net tanımlayın. Anahtar kelimeleri doğal şekilde kullanın.',
      gtmTitle: 'Google Tag Manager',
      gtmDesc: 'Analytics, Ads ve diğer etiketleri tek noktadan yönetin.',
      gtmHint: 'GTM konteyner kodunu Google Tag Manager panelinden kopyalayın. Head kodu <head> içine, body kodu <body> açılışına eklenir.',
      merchantTitle: 'Google Merchant Center',
      merchantDesc: 'Ürün kataloğunuzu Google Alışveriş ve Performance Max kampanyalarına besleyin.',
      merchantSwitch: 'Merchant XML feed yayınla',
      merchantOpen: 'Aç',
      sitemapTitle: 'Site haritası (Sitemap)',
      sitemapDesc: 'Hangi içerik gruplarının sitemap.xml\'e dahil edileceğini seçin ve özel URL ekleyin.',
      sitemapSwitch: 'Site haritası yayınla',
      sitemapSegmentsLabel: 'Sitemap segmentleri',
      segStaticLabel: 'Statik sayfalar',
      segStaticDesc: 'Ana sayfa, ürün listesi, iletişim, KVKK',
      segProductsLabel: 'Ürünler',
      segProductsDesc: 'Yayında olan ürün detay URL\'leri',
      segCategoriesLabel: 'Kategoriler',
      segCategoriesDesc: 'Aktif kategori sayfaları',
      segBlogsLabel: 'Blog yazıları',
      segBlogsDesc: 'Yayında olan blog içerikleri',
      segPagesLabel: 'Özel sayfalar',
      segPagesDesc: 'Yasal ve özel içerik sayfaları',
      customUrlsLabel: 'Özel URL\'ler',
      customUrlsHint: 'Statik site haritasına eklenir. Her satıra bir yol yazın — örn. /kampanya veya tam URL.',
      customUrlsPlaceholder: '/kampanya\n/indirimler\nhttps://example.com/landing',
      liveSitemapLabel: 'Canlı sitemap URL\'leri',
      mainSitemapIndex: 'Ana sitemap index',
      blogRss: 'Blog RSS feed (ayrı)',
      googlePreviewTitle: 'Google önizleme',
      googlePreviewNote: 'Site adı Genel Ayarlar → Site Adı alanından gelir.',
      metaDescEmpty: 'Meta açıklama girilmedi — arama sonuçlarında otomatik metin kullanılabilir.',
      copyUrl: 'Kopyala',
      copyUrlSuccess: 'URL kopyalandı',
      storeName: 'Mağazanız',
    },
    dropdown: {
      contentSaved: 'Dropdown içeriği kaydedildi',
      imageSaved: 'Görsel yüklendi',
      imageUploadFailed: 'Görsel yüklenemedi',
      saveFailed: 'Kaydedilemedi',
      title: 'Dropdown İçeriği — {name}',
      howTitle: 'Mega menü nasıl görünür?',
      howStep1: 'Linkte Dropdown menü işaretli ve kayıtlı olmalı.',
      howStep2: 'En az bir bölüm + link veya görsel promosyon kartı ekleyin.',
      howStep3: 'Mağaza header\'ında tam genişlikte mega menü açılır; kart sağda, bölümler solda listelenir.',
      howStep4: 'Sadece alt linkler varsa (bölüm/kart yok) klasik küçük dropdown kullanılır.',
      sectionsTitle: 'Mega menü bölümleri',
      addSection: 'Bölüm',
      noSections: 'İsteğe bağlı — her bölüm header\'da bir kolon olur. Bölüm başlığı ve renk görünür; linkler altında listelenir.',
      sectionTitle: 'Bölüm başlığı',
      linkText: 'Link metni',
      cardTitle: 'Görsel promosyon kartı',
      cardDesc: 'Header mega menü açıldığında sağ tarafta görünen çoklu görselli CTA kartı. Birden fazla görsel ekleyebilirsiniz; görseller otomatik döner. Başlık, açıklama ve buton boşsa yalnızca görseller gösterilir; tamamen boşsa kart gizlenir.',
      addImage: 'Ekle',
      cardTitleField: 'Kart başlığı',
      cardDescField: 'Açıklama (TR öncelikli)',
      buttonText: 'Buton metni',
      buttonLink: 'Buton linki',
    },
  },

  blogs: {

    cover: {
      label: 'Kapak görseli',
      hint: 'Blog listesi ve detay sayfasında görünür. 16:9 veya 5:2 önerilir · en fazla 5 MB.',
      noImage: 'Henüz görsel yok',
      uploading: 'Yükleniyor…',
      change: 'Değiştir',
      upload: 'Yükle',
      remove: 'Kaldır',
      cancelSelection: 'Seçimi iptal',
      uploadSuccess: 'Kapak görseli yüklendi.',
      removeSuccess: 'Kapak görseli kaldırıldı.',
      pendingNote: 'Görsel kayıt sonrası otomatik yüklenecek.',
      removeConfirm: 'Kapak görselini kaldır?',
    },

    title: 'Blog & Haber',
    tabPosts: 'Blog Yazıları',
    tabCategories: 'Kategoriler',
    bulkTitle: 'Blog Yazıları',
    bulkDesc: 'Tablo ile tek tek düzenleyin; JSON ile mevcut sayfadaki yazıları toplu AI çevirisine gönderin.',
    profileTitles: 'Başlık + kısa özet',
    profileFull: 'Başlık + özet + içerik',
    profileMeta: 'SEO meta',
    addBlog: '+ Yeni Blog',
    searchPlaceholder: 'Başlıkta ara…',
    emptyPosts: 'Blog yazısı bulunamadı',
    colTitle: 'Başlık',
    colCategory: 'Kategori',
    colStatus: 'Durum',
    colViews: 'Görüntülenme',
    colDate: 'Tarih',
    published: 'Yayında',
    draft: 'Taslak',
    saveFailed: 'Hata oluştu',
    deleteConfirm: 'Blog silinsin mi?',
    catDeleteConfirm: 'Kategori silinsin mi?',
    catEmpty: 'Henüz kategori yok.',
    catNamePlaceholder: 'Yeni kategori adı…',
    catEditPlaceholder: 'Kategori adını güncelle…',
    colName: 'Ad',
    colSlug: 'Slug',
    editModal: 'Blog Düzenle',
    newModal: 'Yeni Blog Yazısı',
    shortDescTr: 'Kısa Açıklama (Türkçe)',
    shortDescOther: 'Kısa açıklama (diğer diller)',
    contentTr: 'İçerik (Türkçe) *',
    contentOther: 'İçerik (diğer diller)',
    contentPlaceholder: 'Blog içeriğini düzenleyin…',
    categoryLabel: 'Kategori',
    categorySelect: '— Seçiniz —',
    publishedSwitch: 'Yayında',
    seoTitle: 'SEO Ayarları',
    metaTitleTr: 'Meta Başlık (Türkçe)',
    metaTitleOther: 'Meta başlık (diğer diller)',
    metaDescTr: 'Meta Açıklama (Türkçe)',
    metaDescOther: 'Meta açıklama (diğer diller)',
    metaKeysTr: 'Anahtar Kelimeler (Türkçe)',
    metaKeysOther: 'Anahtar kelimeler (diğer diller)',
    cover: {
      label: 'Kapak görseli',
      hint: 'Blog listesi ve detay sayfasında görünür. 16:9 veya 5:2 önerilir · en fazla 5 MB.',
      noImage: 'Henüz görsel yok',
      uploading: 'Yükleniyor…',
      change: 'Değiştir',
      upload: 'Yükle',
      remove: 'Kaldır',
      cancelSelection: 'Seçimi iptal',
      uploadSuccess: 'Kapak görseli yüklendi.',
      removeSuccess: 'Kapak görseli kaldırıldı.',
      uploadFailed: 'Görsel yüklenemedi. Kotayı veya dosyayı kontrol edin.',
      removeFailed: 'Görsel kaldırılamadı.',
      pendingNote: 'Görsel kayıt sonrası otomatik yüklenecek.',
      confirmRemove: 'Kapak görselini kaldırmak istediğinize emin misiniz?',
      onlyImages: 'Yalnızca görsel dosyaları yüklenebilir (JPEG, PNG, WebP, GIF vb.).',
      maxSize: 'Dosya boyutu en fazla 5 MB olabilir.',
    },
  },

  themes: {
    page: {
      loading: 'Tasarım ayarları yükleniyor…',
      title: 'Tasarım Özelleştirici',
      livePreview: 'Canlı önizleme',
      hasDraft: 'Taslak var',
      changedCount: '{count} değişiklik',
      subtitle: 'Kaydetmeden canlı önizleme; taslak kaydet veya yayınla.',
      platformTheme: 'Platform teması:',
      platformThemeNote: 'Aktif temayı değiştirirseniz tercihiniz vitrinde kalıcı olur.',
      tenantThemeNote: 'Vitrin sizin tema tercihinizi kullanıyor (platform: {id}).',
      previewDevice: 'Önizleme cihazı',
      desktopPreview: 'Masaüstü önizleme',
      mobilePreview: 'Mobil önizleme',
      refreshPreview: 'Önizlemeyi yenile',
      clearCookies: 'Çerezleri temizle',
      openStorefront: 'Vitrini aç',
      draftBtn: 'Taslak',
      draftLinkBtn: 'Taslak linki',
      publishBtn: 'Yayınla',
      saveBtn: 'Kaydet',
      activeTheme: 'Aktif tema',
      selectTheme: 'Tema seçin…',
      storefrontProfile: 'Vitrin profili',
      defaultStorefront: 'Varsayılan vitrin',
      presetLabel: 'Hazır palet…',
      exportLabel: 'Dışa aktar',
      importLabel: 'İçe aktar',
      allowedFields: 'Bu tema için {count} ayar izni tanımlı',
      noSettings: 'Bu tema için düzenlenebilir ayar bulunmuyor.',
      groupCount: '{groups} grup · {fields} ayar',
      iframeTitle: 'Mağaza vitrin önizlemesi',
      savedSuccess: 'Görünüm ayarları yayınlandı.',
      saveError: 'Ayarlar kaydedilirken bir hata oluştu.',
      draftSaved: 'Taslak kaydedildi.',
      draftSaveFailed: 'Taslak kaydedilemedi.',
      published: 'Tema yayınlandı.',
      publishFailed: 'Yayınlama başarısız.',
      draftPreviewLink: 'Taslak önizleme linki kopyalandı',
      presetApplied: '"{label}" paleti uygulandı',
      importSuccess: 'Ayarlar içe aktarıldı',
      importFailed: 'Geçersiz JSON dosyası',
      cookiesCleared: 'Çerezler temizlendi',
      manualDraftLabel: 'Manuel taslak',
    },
    settings: {
      groups: {
        colors: { title: 'Görünüm & Renkler', description: 'Marka renkleri, yüzeyler ve durum renkleri' },
        typography: { title: 'Yazı Tipleri', description: 'Font ailesi, boyutlar ve okunabilirlik' },
        layout: { title: 'Genel Düzen', description: 'Genişlik, boşluklar ve gölge' },
        header_footer: { title: 'Header & Footer', description: 'Üst ve alt bölüm davranışı' },
        commerce: { title: 'Ürün & Vitrin', description: 'Ürün kartı ve liste düzeni' },
        responsive: { title: 'Responsive', description: 'Breakpoint bazlı grid ve boşluklar' },
        branding: { title: 'Logo & Görseller', description: "Hero görselleri (logo ve favicon Genel Ayarlar'dan yönetilir)" },
        dark_mode: { title: 'Karanlık Mod', description: 'Tema modu ve koyu palet' },
        checkout: { title: 'Ödeme & Güven', description: 'Checkout görünümü' },
        codexpin: { title: 'CodexPin Paleti', description: 'E-ticaret temasına özel renk tokenları' },
        advanced: { title: 'İleri Seviye', description: 'Özel CSS ve dışa aktarma' },
      },
      fields: {
        semanticColors: 'Semantic renk zincirleri',
        semanticColorsHint: 'Primary, buton ve yüzey zincirleri — otomatik türetme',
        primaryColor: 'Ana Renk',
        secondaryColor: 'İkincil Renk',
        accentColor: 'Vurgu Rengi',
        bg: 'Sayfa Arka Planı',
        text: 'Ana Metin',
        surface: 'Kart / Panel Yüzeyi',
        textMuted: 'Soluk Metin',
        border: 'Kenarlık',
        linkColor: 'Link Rengi',
        linkHoverColor: 'Link Hover',
        successColor: 'Başarı / Stok',
        warningColor: 'Uyarı',
        errorColor: 'Hata / İndirim',
        headerBg: 'Header Arka Plan',
        headerText: 'Header Metin',
        footerBg: 'Footer Arka Plan',
        footerText: 'Footer Metin',
        buttonBg: 'Buton Arka Plan',
        buttonText: 'Buton Metin',
        buttonHoverBg: 'Buton Hover',
        inputBg: 'Input Arka Plan',
        inputBorder: 'Input Kenarlık',
        fontFamily: 'Gövde Fontu',
        headingFont: 'Başlık Fontu',
        baseFontSize: 'Gövde Boyutu',
        headingWeight: 'Başlık Kalınlığı',
        bodyWeight: 'Gövde Kalınlığı',
        lineHeight: 'Satır Yüksekliği',
        letterSpacing: 'Harf Aralığı',
        h1Size: 'H1 Boyutu',
        h2Size: 'H2 Boyutu',
        h3Size: 'H3 Boyutu',
        h4Size: 'H4 Boyutu',
        typographyScale: 'Tipografi Ölçeği',
        containerWidth: 'İçerik Genişliği',
        borderRadius: 'Kart Köşesi',
        buttonRadius: 'Buton Köşesi',
        shadowSize: 'Gölge',
        widgetGap: 'Widget Arası',
        widgetPadding: 'Widget İç Boşluk',
        sectionPaddingY: 'Bölüm Dikey Boşluk',
        pagePaddingX: 'Sayfa Yatay (Masaüstü)',
        pagePaddingXMobile: 'Sayfa Yatay (Mobil)',
        pagePaddingXTablet: 'Sayfa Yatay (Tablet)',
        animationDuration: 'Animasyon Süresi',
        hoverAnimations: 'Hover animasyonları',
        hoverAnimationsHint: 'Kart ve buton geçiş efektleri',
        headerHeight: 'Header Yüksekliği',
        headerSticky: 'Yapışkan header',
        headerStickyHint: 'Kaydırınca üstte sabit kalır',
        headerTransparent: 'Şeffaf header',
        headerTransparentHint: 'Hero üzerinde saydam görünüm',
        footerColumns: 'Footer Kolon Sayısı',
        footerSocialColor: 'Sosyal İkon Rengi',
        footerCopyright: 'Copyright metni',
        footerCopyrightPlaceholder: '© 2026 Mağaza Adı. Tüm hakları saklıdır.',
        productGridColumns: 'Grid Kolon (Masaüstü)',
        productListStyle: 'Liste Görünümü',
        productCardRadius: 'Ürün Kartı Köşesi',
        priceColor: 'Fiyat Rengi',
        discountBadge: 'İndirim Rozeti',
        cardHoverLift: 'Kart hover kaldırma',
        cardHoverLiftHint: "Hover'da hafif yükselme",
        productGridColumnsSm: 'Grid Kolon (Mobil)',
        productGridColumnsMd: 'Grid Kolon (Tablet)',
        productGridColumnsLg: 'Grid Kolon (Desktop)',
        heroImageUrl: 'Varsayılan Hero Görseli',
        heroOverlayOpacity: 'Hero Overlay Opaklığı',
        colorMode: 'Renk Modu',
        darkPrimaryColor: 'Koyu — Ana Renk',
        darkBg: 'Koyu — Arka Plan',
        darkText: 'Koyu — Metin',
        darkSurface: 'Koyu — Yüzey',
        checkoutStep: 'Adım Göstergesi',
        trustBadges: 'Güven rozetleri',
        trustBadgesHint: 'Ödeme sayfasında SSL / güvenli ödeme',
        cpBg: 'Arka Plan',
        cpText: 'Metin',
        cpRed: 'Kırmızı',
        cpGold: 'Altın',
        cpBlue: 'Mavi',
        showChat: 'Canlı destek balonu',
        showChatHint: 'Sağ altta chat widget',
        navItems: 'Header menüsü',
        navItemsHint: 'Sürükle, sırala ve düzenle',
        tickerItems: 'Ticker metinleri',
        customCss: 'Özel CSS',
        customCssHint: 'Yalnızca güvenilir kod ekleyin. Tüm vitrine enjekte edilir.',
      },
      options: {
        sharp: 'Keskin',
        none: 'Yok',
        light: 'Hafif',
        medium: 'Orta',
        strong: 'Güçlü',
        tight: 'Sıkı',
        normal: 'Normal',
        wide: 'Geniş',
        slightlyWide: 'Hafif geniş',
        slightlyTight: 'Hafif sıkı',
        default16: '16px — Varsayılan',
        semiMedium: '500 — Orta',
        fast: 'Hızlı',
        slow: 'Yavaş',
        compact: 'Kompakt',
        dots: 'Noktalar',
        numbered: 'Numaralı',
        minimal: 'Minimal',
        list: 'Liste',
        lightMode: 'Açık',
        darkMode: 'Koyu',
        auto: 'Sistem (auto)',
        pill: 'Pill',
      },
      presets: {
        defaultLight: 'Açık — Varsayılan',
        darkPro: 'Koyu Pro',
        minimal: 'Minimal',
        vibrant: 'Canlı',
        luxuryGold: 'Paket — Lüks Altın',
        summerBreeze: 'Paket — Yaz Esintisi',
        codexpinNight: 'Paket — CodexPin Gece',
        forest: 'Paket — Orman Yeşili',
        ocean: 'Paket — Okyanus',
        corporate: 'Paket — Kurumsal',
        roseGold: 'Paket — Rose Gold',
      },
    },
  },


  themes: {
    cache: {
      title: 'Önbellek Ayarları',
      description: 'Vitrin sayfalarının otomatik yenilenme aralığını saniye olarak yönetin.',
      hint: 'Tema yayınlandığında önbellek beklemeden temizlenir. 0 değeri ilgili veri önbelleğini kapatır.',
      loading: 'Önbellek ayarları yükleniyor',
      loadError: 'Önbellek ayarları yüklenemedi.',
      homeLabel: 'Anasayfa Önbellek Süresi (sn)',
      homeHint: 'Anasayfa ürün ve tema verilerinin otomatik yenilenme süresi.',
      productLabel: 'Ürün Detay Önbellek Süresi (sn)',
      productHint: 'Ürün detay verilerinin otomatik yenilenme süresi.',
      rangeHint: '0 ile 86400 arasında tam sayı girin.',
      actionsTitle: 'İşlemler',
      saveBtn: 'Ayarları Kaydet',
      refreshBtn: 'Önbelleği Güncelle',
      savedSuccess: 'Önbellek ayarları kaydedildi ve vitrin güncellendi.',
      saveError: 'Önbellek ayarları kaydedilemedi.',
      refreshed: 'Vitrin önbelleği güncellendi.',
      refreshFailed: 'Vitrin önbelleği güncellenemedi.',
    },
    templates: {
      title: 'Sayfa Yönetimi',
      description: 'Vitrin sayfaları için kullanılacak tasarım şablonlarını seçin.',
      activeTheme: 'Aktif tema:',
      previewCategories: 'Kategorileri Önizle',
      noTemplates: 'Bu tema için yapılandırılabilir sayfa şablonu bulunmuyor.',
      saveAndPublish: 'Kaydet ve yayınla',
      publishDraft: 'Taslağı yayınla',
      draftLabel: 'Sayfa şablonları taslak',
      published: 'Sayfa şablonları yayınlandı.',
    },
    customizer: {
      revisionLoaded: 'Sürüm taslağa yüklendi',
      revisionFailed: 'Sürüm yüklenemedi',
      abStarted: 'A/B testi başlatıldı',
      abStopped: 'A/B testi durduruldu',
      abCreated: 'A/B deneyi oluşturuldu',
      abUpdated: 'Deney güncellendi',
      profileCreated: 'Profil oluşturuldu',
      profileFailed: 'Profil oluşturulamadı',
      webhookSaved: 'Webhook kaydedildi',
      webhookFailed: 'Webhook kaydedilemedi',
      tabA11y: 'Erişilebilirlik',
      tabSecurity: 'Güvenlik',
      tabHistory: 'Sürümler',
      tabProfiles: 'Profiller',
      tabAbTest: 'A/B Test',
      tabIntegrations: 'Entegrasyon',
      historyEmpty: 'Henüz revizyon yok.',
      historyRestore: 'Yükle',
      profilesNameLabel: 'Görünen ad',
      profilesPatternLabel: 'Host pattern',
      profilesCreate: 'Profil oluştur',
      profilesLimit: 'Plan limiti: {count} profil',
      customCssLocked: 'Özel CSS kilitli',
      webhookUrlLabel: 'Yayın webhook URL',
      webhookSaveBtn: 'Webhook kaydet',
      integrationsSecretRegistered: '(kayıtlı)',
      integrationsSecretPlaceholder: 'Yeni secret (opsiyonel)',
      abNotAvailable: 'A/B test Kurumsal planda kullanılabilir.',
      abCreateExp: 'Deney oluştur',
      abStart: 'Başlat',
      abStop: 'Durdur',
      abUpdate: 'Güncelle',
    },
    editor: {
      drag: 'Sürükle',
      remove: 'Sil',
      navItemLabel: 'Etiket',
      navDotColor: 'Nokta rengi',
      navSubmenu: 'Alt menü',
      navNewItem: 'Yeni menü öğesi',
      navNoItems: 'Henüz menü öğesi yok.',
      navAddItem: 'Menü öğesi ekle',
      tickerPlaceholder: 'Kampanya metni',
      tickerNewItem: 'Yeni kampanya metni',
      tickerEmpty: 'Ticker metni ekleyin.',
      tickerAddRow: 'Satır ekle',
      semanticAutoDerive: 'Otomatik türet',
      semanticHint: 'Semantic token zincirleri — base rengi değiştirince hover ve kontrast otomatik türetilebilir.',
      abBTrafficLabel: 'B trafiği %',
      abPreviewA: 'Önizle A',
      abPreviewB: 'Önizle B',
      abVariantA: 'Varyant A (mevcut düzenleyici)',
      abVariantB: 'Varyant B',
      abCopyFromA: "A'dan kopyala",
      selectPlaceholder: 'Seçiniz',
      colorPicker: '{label} renk seçici',
    },
  },
  widgets: {
    pages: {
      home: 'Ana Sayfa',
      products: 'Ürünler (Liste)',
      productDetail: 'Ürün Detay',
      categories: 'Kategoriler',
      categoryDetail: 'Kategori Detay',
      cart: 'Sepet',
      checkout: 'Ödeme',
      checkoutSuccess: 'Ödeme Başarılı',
      search: 'Arama Sonuçları',
      blog: 'Blog (Liste)',
      blogDetail: 'Blog Detay',
      contact: 'İletişim',
      about: 'Hakkımızda',
      faq: 'SSS',
      account: 'Hesabım',
      accountOrders: 'Siparişlerim',
      accountFavorites: 'Favorilerim',
      accountProfile: 'Profilim',
      accountAddresses: 'Adreslerim',
      accountWallet: 'Cüzdanım',
      accountTickets: 'Destek Taleplerim',
      login: 'Giriş / Kayıt',
      all: 'Tüm Sayfalar',
    },
    cta: 'SATIN AL',
    guideButton: 'Örnek şablon',
    guideHide: 'Örneği gizle',
    guideTitle: 'Vitrindeki son hali',
    guideSlots: {
      slide: 'Slayt',
      badge: 'Rozet',
      title: 'Başlık',
      art: 'Sanat',
      tab: 'Sekme',
      banner: 'Banner',
      product: 'Ürün',
      category: 'Kategori',
      logo: 'Logo',
      text: 'Metin',
      video: 'Video',
      blog: 'Yazı',
      publisher: 'Yayıncı',
      left: 'Sol',
      center: 'Orta',
      right: 'Sağ',
      top: 'Üst',
      bottom: 'Alt',
      button: 'Buton',
      sidebar: 'Liste',
      cover: 'Kapak',
    },
    guide: {
      slider: 'Her öğe bir slayttır. Görselin üzerine rozet, başlık, alt metin ve buton biner.',
      hero_slider: 'Ortada dönen slayt, sağda banner şeridi ve isteğe bağlı promo kartı vardır.',
      carousel: 'Ortadaki slaytlar görsel ve başlık kullanır. Sol ve sağ banner ayrı birer öğedir.',
      carousel_left: 'Soldaki slaytlar ana alanı kaplar. Sağ üst ve sağ alt bannerlar üst üste durur.',
      cp_hero: 'Her öğe bir sekmedir. Sol metin, sağ sanat görseli ve sekme logosu birlikte çizilir.',
      banner_grid: '1 görsel tam genişlik, 2 görsel yarı yarıya, 3–4 görsel ızgara olur. En fazla 4 öğe.',
      product_grid: 'Seçtiğiniz ürünler kart ızgarasında listelenir. Görsel ve fiyat üründen gelir.',
      full_bg_products: 'Arka plan görseli üzerinde sekmeler ve ürün kartları kayar.',
      advantage_product: 'İndirimli ürün kartları kayar. Elle ürün sabitleyebilir veya en yüksek indirim filtresini kullanabilirsin.',
      popular_product: 'Ürün kartları sonsuz kayar. Elle seçebilir veya popülerlik filtresi kullanabilirsiniz.',
      category_carousel: 'Kategoriler ikon veya görselle yatay şerit halinde dizilir.',
      slide_category: 'Üstte kategori sekmeleri, altta o kategorinin ürün slaytı vardır.',
      horizon_category: 'Bir yanda banner, diğer yanda kaydırılabilir ürün kartları vardır.',
      horizontal_category: 'Solda banner, sağda ürünler ızgara halinde durur.',
      brand_logos: 'Kayıtlı marka logoları şerit olur. Üzerine kendi logonu da ekleyebilirsin.',
      brands_area: 'Kayıtlı marka logoları kayan şerit olur. Eklediğin logolar başta durur.',
      announcement_bar: 'İnce bir banttır. Kısa metin, vurgu rengi ve bağlantı yeterlidir.',
      text_block: 'Serbest metin alanıdır. Başlık ve HTML içerik sayfada blok olarak durur.',
      video_banner: 'Video bağlantısı ortada oynatılır. Kapak görseli video açılmadan görünür.',
      blog_section: 'Yazılar blog kayıtlarından gelir. Bu şablona öğe eklenmez; başlık bölüm ayarındadır.',
      publisher: 'Yayıncı kartları görsel, ad ve bağlantı ile yan yana kayar.',
      cp_featured: 'Her öğe yatay bir kampanya kartıdır. Başlık, bağlantı ve vurgu rengi kullanılır.',
      cp_shop: 'Solda oyun listesi, sağda ürün ızgarası vardır. Ürünler mağazadan gelir.',
      cp_gift: 'Hediye kartı platformları renkli kartlar halinde dizilir.',
      cp_market: 'İlan kartları pazar ızgarasında listelenir.',
      b2b_cta: 'Tek bir çağrı bandıdır. Başlık, kısa metin ve buton yeterlidir.',
      default: 'Öğeler bu şablonda aşağıdaki düzende vitrine yerleşir.',
    },

    // Page title
    pageTitle: 'Widget Yönetimi',
    layoutBuilderTitle: 'Layout Builder',
    addLayout: 'Ekle',
    dragToReorder: 'Sürükle-bırak ile sıra değiştirin',
    loading: 'Yükleniyor...',
    layoutsLoadFailed: 'Sergiler yüklenemedi. Sayfayı yenileyin.',
    noLayouts: 'Sergi bulunamadı. "+ Ekle" ile başlayın.',
    selectOrAddLayout: 'Bir sergi seçin veya yeni ekleyin',
    livePreviewHint: 'Canlı önizleme ve öge düzenleme bu alanda yapılır',
    layoutBgUploadHint: 'Arka plan yüklemek için önce şablon seçin.',
    reorderFailed: 'Sıralama kaydedilemedi',
    itemReorderFailed: 'Öge sıralaması kaydedilemedi',
    layoutSaved: 'Sergi güncellendi',
    layoutCreated: 'Sergi oluşturuldu',
    layoutSaveFailed: 'Kaydedilemedi',
    layoutDeleted: 'Sergi silindi',
    layoutDeleteConfirm: 'Sergi silinsin mi?',
    itemSaved: 'Öge güncellendi',
    itemCreated: 'Öge oluşturuldu',
    itemSaveFailed: 'Kaydedilemedi',
    itemDeleteConfirm: 'Öge silinsin mi?',
    bannerLimitFull: 'Limit dolu — en fazla {max} banner ekleyebilirsiniz.',
    bannerLimitFullShort: 'En fazla {max} banner ekleyebilirsiniz',

    // LayoutCard
    setInactive: 'Pasif yap',
    setActive: 'Aktif yap',
    itemCount: '{count} öge',
    editLayout: 'Düzenle',
    deleteLayout: 'Sil',

    // LayoutFormModal
    editSection: 'Bölüm Düzenle',
    newSection: 'Yeni Bölüm',
    templateLabel: 'Şablon *',
    templateSelect: '— Seçiniz —',
    titleLabel: 'Başlık',
    subtitleLabel: 'Alt Başlık',
    descriptionLabel: 'Açıklama',
    tabAlignLabel: 'Sekme Konumu',
    tabAlignLeft: 'Solda hizala',
    tabAlignCenter: 'Ortada hizala',
    tabAlignHint: 'Kategori sekmelerinin üst barda nasıl hizalanacağını belirler.',
    pageLabel: 'Sayfa',
    transitionLabel: 'Geçiş Efekti',
    transitionSlide: 'Kaydırmalı (Loop)',
    transitionFade: 'Fade',
    orderLabel: 'Sıra',
    bgImageLabel: 'Arka Plan Görseli',
    activeLabel: 'Aktif',
    cancelLabel: 'İptal',
    savingLabel: 'Kaydediliyor...',
    saveLabel: 'Kaydet',

    // ImageUpload
    noUrlReturned: 'Sunucu görsel URL döndürmedi.',
    uploadFailedGeneric: 'Yükleme başarısız.',
    saveLayoutFirstHint: 'Arka plan görseli için önce şablon ve başlığı doldurup kaydedin.',
    itemCreateFailed: 'Öge oluşturulamadı, görsel yüklenemedi.',
    imageOnlyError: 'Sadece görsel dosyalar yüklenebilir.',
    fileSizeError: "Dosya boyutu 5 MB'i geçemez.",
    imageRemoved: 'Görsel kaldırıldı.',

    // ItemCard
    productPrefix: 'Ürün: ',
    categoryPrefix: 'Kategori: ',
    editItem: 'Düzenle',
    deleteItem: 'Sil',

    // ItemFormModal & WidgetEditorCanvas inline editor
    editItemTitle: 'Öge Düzenle',
    newItemTitle: 'Yeni Öge',
    afterSavePreviewRefresh: 'Kayıt sonrası önizleme yenilenir',
    closeEditor: 'Kapat',

    // ItemFormFields
    selectProductLabel: 'Mağaza Ürünü Seç',
    productAutoFillHint: 'Ürün seçilince ad, görsel, fiyat ve bağlantı mağazadan gelir.',
    popularProductPickHint: 'İstediğin ürünü ekle. Başlık, görsel, fiyat ve bağlantı ayrıca yazılmaz. Bölüm ayarındaki filtre kalan yerleri doldurur.',
    productAutoFilled: 'Bu alanlar seçilen üründen geldi.',
    productLoading: 'Ürün bilgisi yükleniyor',
    popularSourceLabel: 'Popülerlik filtresi',
    popularSourceHint: 'Elle eklediğin ürünler başta durur. Filtre, 10 ürüne kadar kalan yerleri doldurur. En uygun fiyat, en düşük mağaza satış fiyatını kullanır.',
    popularSource: {
      manual: 'Yalnızca seçtiğim ürünler',
      bestsellers: 'Çok satılanlar',
      lowest_price: 'En uygun fiyat',
      most_viewed: 'En çok görüntülenenler',
      newest: 'Yeni eklenenler',
    },
    advantageSourceLabel: 'Avantaj filtresi',
    advantageSourceHint: 'Elle eklediğin ürünler başta durur. Filtre, satış fiyatı piyasa fiyatının altında ve stokta olan ürünleri indirim oranına göre 10 ürüne kadar doldurur.',
    advantageProductPickHint: 'İstediğin ürünü sabitle. Filtre kalan yerleri en yüksek indirimle doldurur.',
    advantageSource: {
      manual: 'Yalnızca seçtiğim ürünler',
      highest_discount: 'En yüksek indirim',
    },
    brandSourceLabel: 'Marka kaynağı',
    brandSourceHint: 'Kayıtlı markalar logosu olan aktif markalardır. Üzerine kendi logonu da ekleyebilirsin; eklediklerin başta durur.',
    selectBrandLabel: 'Kayıtlı marka seç',
    brandPickHint: 'Marka seçilince ad, logo ve site adresi gelir. İstersen bunun yerine kendi görselini yükleyebilirsin.',
    brandSource: {
      registered: 'Kayıtlı markalar + eklediklerim',
      manual: 'Yalnızca eklediğim logolar',
    },
    blogItemsUnused: 'Blog yazıları kayıtlardan gelir. Bu şablona öğe eklenmez. Başlık, alt başlık ve açıklama bölüm ayarındadır.',
    selectCategoryLabel: 'Mağaza Kategorisi Seç',
    selectTabProductsLabel: 'Bu Sekme İçin Ürünleri Seç',
    selectCategoryProductsLabel: 'Kategori Ürünlerini Seç',
    categoryCarouselDesc: 'Her öge bir kategori sekmesidir. Seçilen ürünler yalnızca bu kategoride listelenir.',
    horizontalCategoryDesc: 'Banner yanında gösterilecek ürünler (en fazla {max}, 3x3 grid).',
    bannerCategoryDesc: 'Banner yanında gösterilecek ürünler. Her öge ayrı bir vitrin bloğudur.',
    defaultCategoryDesc: 'Seçilen ürünler bu kategori altında vitrinde listelenecektir.',
    showCategoryNameLabel: 'Sekmede kategori adını göster',
    showCategoryNameHint: 'Kapalıysa yalnızca kategori görseli görünür.',
    bannerPositionLabel: 'Banner Konumu',
    bannerLeft: 'Banner solda',
    bannerRight: 'Banner sağda',
    announcementTextLabel: 'Duyuru metni',
    announcementPlaceholder: 'Örnek: 7/24 otomatik teslimat aktif — tüm e-pinlerde geçerli',
    announcementVisuals: 'Duyuru görünümü (opsiyonel)',
    badgeLabel: 'Rozet',
    eyebrowLabel: 'Etiket',
    ctaButtonLabel: 'Buton metni',
    colorLabel: 'Vurgu rengi',
    contentFieldLabel: 'İçerik',
    contentPlaceholder: 'Metin bloğu içeriği...',
    videoUrlLabel: 'Video URL',
    coverImageLabel: 'Kapak Görseli',
    slideImageLabel: 'Slide Görseli',
    productImageLabel: 'Ürün Görseli',
    categoryImageLabel: 'Kategori Görseli',
    brandLogoLabel: 'Marka Logosu',
    bannerImageLabel: 'Banner Görseli',
    videoFallbackHint: 'Video yüklenmezse gösterilir',
    rightPanelImageLabel: 'Sağ Panel / Sanat Görseli',
    tabLogoLabel: 'Sekme Logosu',
    headlineLabel: 'Ana Başlık',
    subTextLabel: 'Alt Metin',
    ctaTextLabel: 'CTA Metni',
    accentColorLabel: 'Vurgu Rengi',
    showArtLabel: 'Slide Görselini Göster',
    showArtHint: 'Kapalıysa yalnızca gradyan arkaplan + metin gösterilir',
    carouselItemHint: 'Bu şablon yalnızca görsel, başlık, bağlantı ve pozisyon kullanır. Sağ panel, sekme logosu, rozet ve metin alanları CodexPin Hero Slide içindir.',
    positionLabel: 'Pozisyon',
    sliderLeft: 'Sol Slider',
    bannerTopRight: 'Sağ Üst Banner',
    bannerBottomRight: 'Sağ Alt Banner',
    sliderCenter: 'Orta Slider',
    bannerLeftLabel: 'Sol Banner',
    bannerRightLabel: 'Sağ Banner',
    priceLabel: 'Fiyat (TRY)',
    cancelBtn: 'İptal',
    savingBtn: 'Kaydediliyor...',
    addBtn: 'Ekle',
    updateBtn: 'Güncelle',

    // WidgetEditorCanvas specific
    itemsTitle: 'Ögeler',
    clickToEdit: 'karta tıklayarak düzenleyin',
    desktopTitle: 'Masaüstü',
    mobileTitle: 'Mobil',
    fitToScreen: 'Layoutu ekrana sığdır',
    fitToWidth: 'Genişliğe göre (dikey kaydır)',
    refreshPreview: 'Önizlemeyi yenile',
    openInNewTab: 'Yeni sekmede aç',
    editSection2: 'Sergi',
    addItem: 'Öge',
    deleteItemAria: 'Ögeyi sil',
    itemAria: 'Öge: {title}',
    noItemsYet: 'Henüz öge yok — "Öge Ekle" ile başlayın',
    leftSlider: 'Sol slider · sürükle',
    leftSliderNoItems: 'Slider ögesi yok',
    rightTopBottom: 'Sağ (üst/alt)',
    topBannerEmpty: 'Üst banner yok',
    bottomBannerEmpty: 'Alt banner yok',
    leftBannerEmpty: 'Sol banner yok',
    rightBannerEmpty: 'Sağ banner yok',
    centerSlider: 'Orta slider · sürükle',
    leftLabel: 'Sol',
    rightLabel: 'Sağ',
    bannerLimitNote: 'Banner limiti doldu ({count}/{max})',

    // WidgetPreviewFrame
    previewLoading: 'Önizleme yükleniyor…',
    previewFailed: 'Önizleme açılamadı',
    openInNewTabLink: 'Yeni sekmede aç',
    fitLayout: 'Tüm layout sığdırıldı',
    fitWidth: 'Genişliğe göre',
    previewIframeTitle: 'Widget canlı önizleme',

    // SimpleSelects
    categorySearch: 'Kategori ara...',

    // ImageUpload inline labels
    uploadClickOrDrag: 'Tıkla veya sürükle',
    uploadFormatHint: 'JPG, PNG, WebP — maks. 5 MB',
    uploadChanging: 'Değiştir',
    uploadRemoveBtn: 'Görseli kaldır',

    // ItemFormFields
    templatePrefix: 'Şablon:',
    topBarLabel: 'Üst Bar Metni',
    rightBannerOption: 'Sağ Banner',
    layoutMissingErr: 'Layout seçilmedi',
  },

  shared: {
    comingSoon: {
      badge: 'Yakında',
      defaultDescription: 'Bu bölüm henüz geliştirilmedi. Yakında aktif olacak.',
    },
    placeholder: {
      apiNote: 'Bu bölüm yakında API ile bağlanacak.',
    },
  },

  faq: {
    title: 'SSS Yönetimi',
    subtitle: 'Sıkça sorulan soruları yönetin — storefront\'ta /faq adresinde listelenir',
    addQuestion: 'Soru Ekle',
    searchPlaceholder: 'Soru ara...',
    emptyTitle: 'Henüz SSS eklenmedi',
    emptyDesc: 'Müşterilerinizin sık sorduğu soruları buradan ekleyebilirsiniz.',
    addFirst: 'İlk soruyu ekle',
    colTitle: 'Başlık',
    colOrder: 'Sıra',
    colStatus: 'Durum',
    colUpdated: 'Güncelleme',
    published: 'Yayında',
    hidden: 'Gizli',
    editModal: 'SSS Düzenle',
    newModal: 'Yeni SSS',
    questionLabel: 'Soru *',
    iconLabel: 'İkon (opsiyonel)',
    answerLabel: 'Cevap *',
    orderLabel: 'Sıra',
    deleteConfirm: 'Bu soru silinsin mi?',
    savingLabel: 'Kaydediliyor…',
    updateLabel: 'Güncelle',
  },

  pages: {
    title: 'Sayfa Yönetimi',
    subtitle: 'KVKK, Hakkında, Gizlilik Politikası gibi statik sayfalar',
    addPage: '+ Sayfa Ekle',
    colTitle: 'Başlık',
    colSlug: 'Slug',
    colOrder: 'Sıra',
    colStatus: 'Durum',
    colUpdated: 'Güncelleme',
    published: 'Yayında',
    hidden: 'Gizli',
    editModal: 'Sayfa Düzenle',
    newModal: 'Yeni Sayfa',
    titleLabel: 'Başlık *',
    iconLabel: 'İkon (opsiyonel)',
    contentLabel: 'İçerik *',
    contentPlaceholder: 'Sayfa içeriğini yazın...',
    orderLabel: 'Sıra',
    deleteConfirm: 'Sayfa silinsin mi?',
    emptyPage: 'Henüz sayfa eklenmedi.',
    storefrontNote: 'Sayfalar storefront\'ta /pages/[slug] adresinden erişilebilir.',
    savingLabel: 'Kaydediliyor…',
    updateLabel: 'Güncelle',
  },

  menus: {
    title: 'Menü Yönetimi',
    subtitle: 'Dropdown menüler için önce "Dropdown menü" seçeneğiyle bir ana link oluşturun, sonra alt link ekleyin.',
    addLink: '+ Link Ekle',
    posTop: 'Üst Menü',
    posFooter: 'Footer',
    posMobile: 'Mobil Menü',
    emptyTitle: 'Bu konumda henüz link yok',
    emptyDesc: 'Yeni bir link eklemek için yukarıdaki butonu kullanın.',
    colOrder: 'Sıra',
    colTitle: 'Başlık',
    colUrl: 'URL',
    colStatus: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    addChildLink: '+ Alt Link',
    editModal: 'Link Düzenle',
    addChildModal: 'Alt Link Ekle',
    newModal: 'Yeni Link',
    parentLink: 'Üst Link (dropdown)',
    noParent: '— Yok (kök link) —',
    parentLinkHint: 'Bu link bir dropdown\'un altında görünecekse üst linki seçin',
    positionLabel: 'Konum *',
    titleLabel: 'Başlık *',
    urlLabel: 'URL',
    iconLabel: 'İkon (CSS sınıfı)',
    orderLabel: 'Sıra',
    dropdown: 'Dropdown menü',
    deleteConfirm: '{title}{hasChildren} silinsin mi?',
    deleteWithChildren: ' ve alt linkleri',
    savingLabel: 'Kaydediliyor...',
    loadingLabel: 'Yükleniyor...',
  },

  templates: {
    title: 'E-posta & Bildirim Şablonları',
    subtitle: 'Sipariş, fatura ve sistem bildirimleri için şablonları düzenleyin.',
    tabEmail: 'E-posta şablonları',
    tabSms: 'SMS / WhatsApp',
    tabAddresses: 'E-posta adresleri',
    newTemplate: 'Yeni şablon',
    emailSaved: 'E-posta şablonu kaydedildi',
    notifSaved: 'Bildirim şablonu kaydedildi',
    saveFailed: 'Kayıt başarısız',
    deleted: 'Silindi',
    deleteConfirm: 'Silinsin mi?',
    colKey: 'Anahtar',
    colSubject: 'Konu',
    colStatus: 'Durum',
    colChannel: 'Kanal',
    colLocale: 'Dil',
    active: 'Aktif',
    inactive: 'Pasif',
    editEmailModal: 'E-posta şablonu düzenle',
    newEmailModal: 'Yeni e-posta şablon',
    editNotifModal: 'Bildirim şablonu düzenle',
    newNotifModal: 'Yeni bildirim şablonu',
    keyLabel: 'Anahtar (name)',
    subjectLabel: 'Konu',
    contentLabel: 'İçerik',
    messageLabel: 'Mesaj',
    channelLabel: 'Kanal',
  },

  content: {
    translations: {
    table: 'Tablo',
    json: 'JSON',
    allFields: 'Tüm alanlar',
    fieldSet: 'Alan seti',
    longHtml: 'uzun HTML',
    scopeAlert: 'Kapsam: {note}. Tüm kataloğu çevirmek için arama/filtre + sayfa sayfa ilerleyin veya tek dil JSON\'unu birleştirip kaydedin.',
    loadingTranslations: 'Çeviriler yükleniyor… ({count} kayıt)',
    noJsonRecords: 'JSON için bu kapsamda kayıt yok. Filtreyi genişletin veya tabloya kayıt ekleyin.',
    heavyWarning: 'Bu set uzun HTML içerir. AI\'ya gönderirken sayfa boyutuna dikkat edin; gerekirse yalnızca başlık/kısa alan setini kullanın.',
    importSuccess: '{entities} kayıt · {fields} alan güncellendi',
    jsonSaveFailed: 'JSON kaydı başarısız',
    importEmpty: 'İçe aktarılacak kayıt yok',
    hint: 'Toplu çeviri: kopyala → AI → yapıştır → kaydet.',
    copySuccess: '{lang} JSON panoya kopyalandı',
    copyAllSuccess: 'Tüm katalog JSON kopyalandı',
    copyFailed: 'Kopyalama başarısız',
    defaultHint: 'JSON\'u kopyala → AI ile çevir → yapıştır → kaydet. Tek dil düz obje için hedef dil seçicisini kullan.',
    copyLocale: '{lang} kopyala',
    copyAll: 'Tümünü kopyala',
    saveJson: 'JSON\'u kaydet',
    jsonAriaLabel: 'Çeviri JSON editörü',
    targetLang: 'Hedef / kopyala dili',
    jsonHint: "JSON'u kopyala → AI ile çevir → yapıştır → kaydet. Tek dil düz obje için hedef dil seçicisini kullan.",
    jsonEditorAria: 'Çeviri JSON editörü',
  }
  },
}

export const en: Dictionary = {
  siteContents: {
    title: 'Site Contents',
    description: 'Menus, legal pages, UI translations, GDPR/cookies, and SEO settings — all in one panel.',
    tabs: {
      header: 'Header Menu',
      footer: 'Footer',
      legal: 'Legal Pages',
      faq: 'FAQ',
      contents: 'Custom Content',
      ui: 'UI Translations',
      kvkk: 'GDPR / Cookies',
      seo: 'SEO & Analytics',
    },
    header: {
      title: 'Top Menu (Header)',
      description: 'Main navigation links and dropdown menus',
    },
    footer: {
      title: 'Footer Menu',
      description: 'Each column appears as a titled link list in the storefront. Edit individually in the table, or use JSON for bulk AI translation.',
      columnPrefix: '[Column]',
      addColumn: 'Add Column',
      saved: 'Footer column saved',
      saveFailed: 'Column could not be saved',
      deleted: 'Column deleted',
      linksSaved: 'Links saved',
      linksSaveFailed: 'Links could not be saved',
      structureTitle: 'Footer structure',
      structureStep1: 'Column = the heading in a footer column (e.g. Store, Account).',
      structureStep2: 'Expand a column and add links; Save to reflect changes in the storefront.',
      structureStep3: 'The Order field controls the display order of columns and links.',
      structureStep4: 'Multi-language: TR/EN/DE/RU translations for column headings and each link label.',
      emptyTitle: 'No footer columns yet',
      emptyDesc: 'Get started by adding columns like Store, Account, Support, and Legal.',
      addFirst: 'Add first column',
      orderAndLinks: 'Order {order} · {count} links',
      editColumn: 'Edit column',
      deleteColumn: 'Delete column',
      deleteConfirm: 'Delete "{title}" and all its links?',
      columnLinks: 'Column links',
      noLinks: 'No links in this column yet.',
      linkN: 'Link #{n}',
      removeLink: 'Remove link',
      linkText: 'Link text',
      saveLinks: 'Save Links',
      editModal: 'Edit Footer Column',
      newModal: 'New Footer Column',
      columnTitle: 'Column title *',
      columnTitlePlaceholder: 'Store, Account, Support…',
    },
    menus: {
      addLink: '+ Add Link',
      megaMenuTitle: 'Mega menu setup',
      megaStep1: 'Check the Dropdown menu box on a new or existing header link and save.',
      megaStep2: 'Click the Dropdown button on the row in the table.',
      megaStep3: 'Add sections and links; optionally add an image and CTA to the promotional card on the right.',
      megaStep4: 'After saving, the mega menu appears automatically in the storefront (if no content, a classic dropdown with sub-links is used).',
      emptyTitle: 'No links yet',
      emptyDesc: 'Add a new menu link.',
      addEmptyLink: 'Add link',
      colOrder: 'Order',
      colTitle: 'Title',
      colUrl: 'URL',
      colStatus: 'Status',
      addChild: '+ Sub',
      editModal: 'Edit Link',
      addChildModal: 'Add Sub Link',
      newModal: 'New Link',
      parentLink: 'Parent Link (dropdown)',
      noParent: '— None (root link) —',
      linkTitle: 'Title *',
      orderLabel: 'Order',
      dropdown: 'Dropdown menu',
      dropdownHint: 'After saving, a Dropdown button will appear in the list. Use it to manage mega menu sections and the visual promotional card on the right. If you only want to add sub-links, leave the sections and card empty.',
      deleteConfirm: 'Delete {title}?',
      inlineBulkDesc: 'Edit individually in the table, or use JSON for bulk AI translation.',
    },
    legal: {
      title: 'Legal & Static Pages',
      description: 'GDPR, privacy policy, about us, and similar pages. Edit individually in the table, or use JSON for bulk AI translation.',
      addPage: '+ Add Page',
      emptyTitle: 'No pages yet',
      emptyDesc: 'Add a legal or corporate page.',
      addPageEmpty: 'Add page',
      colTitle: 'Title',
      colSlug: 'Slug',
      colOrder: 'Order',
      colStatus: 'Status',
      published: 'Published',
      hidden: 'Hidden',
      editModal: 'Edit Page',
      newModal: 'New Page',
      contentTr: 'Content (Turkish) *',
      contentOther: 'Content (other languages)',
    },
    faqTab: {
      title: 'FAQ',
      description: 'Frequently asked questions — listed at /faq in the storefront. Edit individually in the table, or use JSON for bulk AI translation.',
      addQuestion: '+ Add Question',
      searchPlaceholder: 'Search questions...',
      emptyTitle: 'No FAQ entries yet',
      emptyDesc: 'Add your first question.',
      addEmpty: 'Add question',
      colQuestion: 'Question',
      colOrder: 'Order',
      colStatus: 'Status',
      published: 'Published',
      hidden: 'Hidden',
      editModal: 'Edit FAQ',
      newModal: 'New FAQ',
      questionLabel: 'Question *',
      answerTr: 'Answer (Turkish) *',
      answerOther: 'Answer (other languages)',
    },
    contents: {
      description: 'Custom content blocks identified by page and section key. Examples: home / hero, about / intro, contact / sidebar',
      addContent: '+ Add Content',
      searchPlaceholder: 'Search page or section…',
      emptyTitle: 'No content',
      emptyDesc: 'Add a new content block.',
      colPage: 'Page',
      colSection: 'Section',
      colType: 'Type',
      colStatus: 'Status',
      previewLink: 'Preview',
      previewTitle: 'View in storefront',
      active: 'Active',
      inactive: 'Inactive',
      saved: 'Content updated',
      added: 'Content added',
      deleted: 'Content deleted',
      saveFailed: 'Could not save',
      deleteFailed: 'Could not delete',
      deleteConfirm: 'Delete this content block?',
      editModal: 'Edit Content',
      newModal: 'New Content',
      pageLabel: 'Page (page)',
      sectionLabel: 'Section (section)',
      typeLabel: 'Content type',
      typeText: 'Text',
      storeLocation: 'Store location:',
    },
    ui: {
      alertInfo: 'Table: edit entries one by one. JSON: copy the file → paste into AI → paste translated JSON → save.',
      alertFormat: 'Format:',
      alertSingleLang: '(+ target language)',
      searchPlaceholder: 'Search key or text…',
      allGroups: 'All groups',
      custom: 'Custom',
      saveJson: 'Save JSON',
      savedCount: '{count} translations saved',
      saveFailed: 'Save failed',
      importedCount: 'JSON imported: {count} records',
      jsonSaveFailed: 'JSON save failed',
      seedSuccess: 'Defaults: {inserted} added, {skipped} skipped',
      seedFailed: 'Seed failed',
      copyOneLang: '{lang} JSON copied to clipboard',
      copyAll: 'All languages copied as JSON',
      copyFailed: 'Copy failed',
      importEmpty: 'Nothing to import',
      invalidJson: 'Invalid JSON',
      reset: 'Reset',
      copyLocale: 'Copy {lang}',
      copyAllLangs: 'Copy all languages',
      jsonAriaLabel: 'UI translations JSON',
      noTranslations: 'No translations found. Use "Load defaults" to populate the catalog.',
      colKey: 'Key',
      tipTitle: 'Tip:',
      tip: 'Copy TR or EN → ask AI to "generate DE JSON with the same keys" → paste the result here → Save JSON. If you paste a flat single-language object, the target language selector on the left will be used.',
      jsonFormatError: 'Format: { "de": { "nav.cart": "..." } } or single-language { "nav.cart": "..." }',
      jsonMustBeObject: 'JSON must be an object',
    },
    seo: {
      loading: 'Loading SEO settings…',
      loadFailed: 'Failed to load SEO settings.',
      saved: 'SEO & analytics settings saved.',
      saveFailed: 'Save failed',
      saveBtn: 'Save changes',
      pillMetaDesc: 'Meta description',
      pillGtm: 'GTM',
      pillMerchant: 'Merchant feed',
      pillSitemap: 'Sitemap',
      configured: 'Configured',
      missing: 'Missing',
      metaTitle: 'Meta & search appearance',
      metaDesc2: 'Control how your storefront appears in Google and other search engines.',
      metaDescLabel: 'Meta description',
      metaDescLength: '{len} / 160 ·',
      metaDescNotEntered: 'Not entered yet',
      metaDescIdeal: 'Ideal length',
      metaDescBitLong: 'A bit long',
      metaDescTooLong: 'Too long — shorten it',
      metaDescPlaceholder: 'Briefly and clearly describe your store. Use keywords naturally.',
      gtmTitle: 'Google Tag Manager',
      gtmDesc: 'Manage analytics, ads, and other tags from a single place.',
      gtmHint: 'Copy the GTM container code from your Google Tag Manager dashboard. The head snippet goes inside <head>, the body snippet at the opening of <body>.',
      merchantTitle: 'Google Merchant Center',
      merchantDesc: 'Feed your product catalog into Google Shopping and Performance Max campaigns.',
      merchantSwitch: 'Publish Merchant XML feed',
      merchantOpen: 'Open',
      sitemapTitle: 'Sitemap',
      sitemapDesc: 'Choose which content groups to include in sitemap.xml and add custom URLs.',
      sitemapSwitch: 'Publish sitemap',
      sitemapSegmentsLabel: 'Sitemap segments',
      segStaticLabel: 'Static pages',
      segStaticDesc: 'Home, product list, contact, GDPR',
      segProductsLabel: 'Products',
      segProductsDesc: 'Published product detail URLs',
      segCategoriesLabel: 'Categories',
      segCategoriesDesc: 'Active category pages',
      segBlogsLabel: 'Blog posts',
      segBlogsDesc: 'Published blog content',
      segPagesLabel: 'Custom pages',
      segPagesDesc: 'Legal and custom content pages',
      customUrlsLabel: 'Custom URLs',
      customUrlsHint: 'Added to the static sitemap. Enter one path per line — e.g. /campaign or a full URL.',
      customUrlsPlaceholder: '/campaign\n/deals\nhttps://example.com/landing',
      liveSitemapLabel: 'Live sitemap URLs',
      mainSitemapIndex: 'Main sitemap index',
      blogRss: 'Blog RSS feed (separate)',
      googlePreviewTitle: 'Google preview',
      googlePreviewNote: 'Site name comes from General Settings → Site Name.',
      metaDescEmpty: 'No meta description entered — search engines may use auto-generated text.',
      copyUrl: 'Copy',
      copyUrlSuccess: 'URL copied',
      storeName: 'Your store',
    },
    dropdown: {
      contentSaved: 'Dropdown content saved',
      imageSaved: 'Image uploaded',
      imageUploadFailed: 'Image upload failed',
      saveFailed: 'Could not save',
      title: 'Dropdown Content — {name}',
      howTitle: 'How does the mega menu look?',
      howStep1: 'The link must have Dropdown menu checked and saved.',
      howStep2: 'Add at least one section + link or a visual promotional card.',
      howStep3: 'A full-width mega menu opens in the storefront header; the card is on the right, sections on the left.',
      howStep4: 'If there are only sub-links (no sections or card), a classic small dropdown is used.',
      sectionsTitle: 'Mega menu sections',
      addSection: 'Section',
      noSections: 'Optional — each section becomes a column in the header. The section title and color are shown; links are listed below.',
      sectionTitle: 'Section title',
      linkText: 'Link text',
      cardTitle: 'Visual promotional card',
      cardDesc: 'A multi-image CTA card displayed on the right when the mega menu opens. You can add multiple images; they rotate automatically. If the title, description, and button are empty, only images are shown; if everything is empty, the card is hidden.',
      addImage: 'Add',
      cardTitleField: 'Card title',
      cardDescField: 'Description (Turkish primary)',
      buttonText: 'Button text',
      buttonLink: 'Button link',
    },
  },

  blogs: {
    title: 'Blog & News',
    tabPosts: 'Blog Posts',
    tabCategories: 'Categories',
    bulkTitle: 'Blog Posts',
    bulkDesc: 'Edit individually in the table; use JSON to bulk-translate posts on the current page with AI.',
    profileTitles: 'Title + short summary',
    profileFull: 'Title + summary + content',
    profileMeta: 'SEO meta',
    addBlog: '+ New Post',
    searchPlaceholder: 'Search by title…',
    emptyPosts: 'No blog posts found',
    colTitle: 'Title',
    colCategory: 'Category',
    colStatus: 'Status',
    colViews: 'Views',
    colDate: 'Date',
    published: 'Published',
    draft: 'Draft',
    saveFailed: 'An error occurred',
    deleteConfirm: 'Delete this blog post?',
    catDeleteConfirm: 'Delete this category?',
    catEmpty: 'No categories yet.',
    catNamePlaceholder: 'New category name…',
    catEditPlaceholder: 'Update category name…',
    colName: 'Name',
    colSlug: 'Slug',
    editModal: 'Edit Post',
    newModal: 'New Blog Post',
    shortDescTr: 'Short Description (Turkish)',
    shortDescOther: 'Short description (other languages)',
    contentTr: 'Content (Turkish) *',
    contentOther: 'Content (other languages)',
    contentPlaceholder: 'Edit blog content…',
    categoryLabel: 'Category',
    categorySelect: '— Select —',
    publishedSwitch: 'Published',
    seoTitle: 'SEO Settings',
    metaTitleTr: 'Meta Title (Turkish)',
    metaTitleOther: 'Meta title (other languages)',
    metaDescTr: 'Meta Description (Turkish)',
    metaDescOther: 'Meta description (other languages)',
    metaKeysTr: 'Keywords (Turkish)',
    metaKeysOther: 'Keywords (other languages)',
    cover: {
      label: 'Cover image',
      hint: 'Shown in the blog list and detail page. 16:9 or 5:2 recommended · max 5 MB.',
      noImage: 'No image yet',
      uploading: 'Uploading…',
      change: 'Change',
      upload: 'Upload',
      remove: 'Remove',
      cancelSelection: 'Cancel selection',
      uploadSuccess: 'Cover image uploaded.',
      removeSuccess: 'Cover image removed.',
      uploadFailed: 'Image upload failed. Check your quota or the file.',
      removeFailed: 'Could not remove image.',
      pendingNote: 'Image will be uploaded automatically after saving.',
      confirmRemove: 'Are you sure you want to remove the cover image?',
      onlyImages: 'Only image files can be uploaded (JPEG, PNG, WebP, GIF, etc.).',
      maxSize: 'File size must be 5 MB or less.',
    },
  },

  themes: {
    page: {
      loading: 'Loading design settings…',
      title: 'Theme Customizer',
      livePreview: 'Live preview',
      hasDraft: 'Draft pending',
      changedCount: '{count} changes',
      subtitle: 'Live preview without saving; save as draft or publish.',
      platformTheme: 'Platform theme:',
      platformThemeNote: 'Changing the active theme makes your preference permanent in the storefront.',
      tenantThemeNote: 'The storefront is using your theme preference (platform: {id}).',
      previewDevice: 'Preview device',
      desktopPreview: 'Desktop preview',
      mobilePreview: 'Mobile preview',
      refreshPreview: 'Refresh preview',
      clearCookies: 'Clear cookies',
      openStorefront: 'Open storefront',
      draftBtn: 'Draft',
      draftLinkBtn: 'Draft link',
      publishBtn: 'Publish',
      saveBtn: 'Save',
      activeTheme: 'Active theme',
      selectTheme: 'Select theme…',
      storefrontProfile: 'Storefront profile',
      defaultStorefront: 'Default storefront',
      presetLabel: 'Apply preset…',
      exportLabel: 'Export',
      importLabel: 'Import',
      allowedFields: '{count} setting permissions defined for this theme',
      noSettings: 'No editable settings for this theme.',
      groupCount: '{groups} groups · {fields} settings',
      iframeTitle: 'Storefront preview',
      savedSuccess: 'Theme settings published.',
      saveError: 'An error occurred while saving settings.',
      draftSaved: 'Draft saved.',
      draftSaveFailed: 'Could not save draft.',
      published: 'Theme published.',
      publishFailed: 'Publish failed.',
      draftPreviewLink: 'Draft preview link copied',
      presetApplied: '"{label}" palette applied',
      importSuccess: 'Settings imported',
      importFailed: 'Invalid JSON file',
      cookiesCleared: 'Cookies cleared',
      manualDraftLabel: 'Manual draft',
    },
    settings: {
      groups: {
        colors: { title: 'Appearance & Colors', description: 'Brand colors, surfaces, and status colors' },
        typography: { title: 'Typography', description: 'Font family, sizes, and readability' },
        layout: { title: 'General Layout', description: 'Width, spacing, and shadow' },
        header_footer: { title: 'Header & Footer', description: 'Top and bottom section behavior' },
        commerce: { title: 'Products & Storefront', description: 'Product card and list layout' },
        responsive: { title: 'Responsive', description: 'Breakpoint-based grid and spacing' },
        branding: { title: 'Logo & Images', description: 'Hero images (logo and favicon managed in General Settings)' },
        dark_mode: { title: 'Dark Mode', description: 'Theme mode and dark palette' },
        checkout: { title: 'Checkout & Trust', description: 'Checkout appearance' },
        codexpin: { title: 'CodexPin Palette', description: 'Custom color tokens for the e-commerce theme' },
        advanced: { title: 'Advanced', description: 'Custom CSS and export' },
      },
      fields: {
        semanticColors: 'Semantic color chains',
        semanticColorsHint: 'Primary, button, and surface chains — auto-derivation',
        primaryColor: 'Primary Color',
        secondaryColor: 'Secondary Color',
        accentColor: 'Accent Color',
        bg: 'Page Background',
        text: 'Main Text',
        surface: 'Card / Panel Surface',
        textMuted: 'Muted Text',
        border: 'Border',
        linkColor: 'Link Color',
        linkHoverColor: 'Link Hover',
        successColor: 'Success / Stock',
        warningColor: 'Warning',
        errorColor: 'Error / Discount',
        headerBg: 'Header Background',
        headerText: 'Header Text',
        footerBg: 'Footer Background',
        footerText: 'Footer Text',
        buttonBg: 'Button Background',
        buttonText: 'Button Text',
        buttonHoverBg: 'Button Hover',
        inputBg: 'Input Background',
        inputBorder: 'Input Border',
        fontFamily: 'Body Font',
        headingFont: 'Heading Font',
        baseFontSize: 'Body Size',
        headingWeight: 'Heading Weight',
        bodyWeight: 'Body Weight',
        lineHeight: 'Line Height',
        letterSpacing: 'Letter Spacing',
        h1Size: 'H1 Size',
        h2Size: 'H2 Size',
        h3Size: 'H3 Size',
        h4Size: 'H4 Size',
        typographyScale: 'Typography Scale',
        containerWidth: 'Content Width',
        borderRadius: 'Card Corner',
        buttonRadius: 'Button Corner',
        shadowSize: 'Shadow',
        widgetGap: 'Widget Gap',
        widgetPadding: 'Widget Padding',
        sectionPaddingY: 'Section Vertical Padding',
        pagePaddingX: 'Page Horizontal (Desktop)',
        pagePaddingXMobile: 'Page Horizontal (Mobile)',
        pagePaddingXTablet: 'Page Horizontal (Tablet)',
        animationDuration: 'Animation Duration',
        hoverAnimations: 'Hover animations',
        hoverAnimationsHint: 'Card and button transition effects',
        headerHeight: 'Header Height',
        headerSticky: 'Sticky header',
        headerStickyHint: 'Stays fixed at top while scrolling',
        headerTransparent: 'Transparent header',
        headerTransparentHint: 'Transparent appearance over hero',
        footerColumns: 'Footer Column Count',
        footerSocialColor: 'Social Icon Color',
        footerCopyright: 'Copyright text',
        footerCopyrightPlaceholder: '© 2026 Store Name. All rights reserved.',
        productGridColumns: 'Grid Columns (Desktop)',
        productListStyle: 'List View',
        productCardRadius: 'Product Card Corner',
        priceColor: 'Price Color',
        discountBadge: 'Discount Badge',
        cardHoverLift: 'Card hover lift',
        cardHoverLiftHint: 'Slight elevation on hover',
        productGridColumnsSm: 'Grid Columns (Mobile)',
        productGridColumnsMd: 'Grid Columns (Tablet)',
        productGridColumnsLg: 'Grid Columns (Desktop)',
        heroImageUrl: 'Default Hero Image',
        heroOverlayOpacity: 'Hero Overlay Opacity',
        colorMode: 'Color Mode',
        darkPrimaryColor: 'Dark — Primary Color',
        darkBg: 'Dark — Background',
        darkText: 'Dark — Text',
        darkSurface: 'Dark — Surface',
        checkoutStep: 'Step Indicator',
        trustBadges: 'Trust badges',
        trustBadgesHint: 'SSL / secure payment on checkout page',
        cpBg: 'Background',
        cpText: 'Text',
        cpRed: 'Red',
        cpGold: 'Gold',
        cpBlue: 'Blue',
        showChat: 'Live support bubble',
        showChatHint: 'Chat widget in bottom right',
        navItems: 'Header menu',
        navItemsHint: 'Drag, sort, and edit',
        tickerItems: 'Ticker texts',
        customCss: 'Custom CSS',
        customCssHint: 'Only add trusted code. Injected into the entire storefront.',
      },
      options: {
        sharp: 'Sharp',
        none: 'None',
        light: 'Light',
        medium: 'Medium',
        strong: 'Strong',
        tight: 'Tight',
        normal: 'Normal',
        wide: 'Wide',
        slightlyWide: 'Slightly wide',
        slightlyTight: 'Slightly tight',
        default16: '16px — Default',
        semiMedium: '500 — Medium',
        fast: 'Fast',
        slow: 'Slow',
        compact: 'Compact',
        dots: 'Dots',
        numbered: 'Numbered',
        minimal: 'Minimal',
        list: 'List',
        lightMode: 'Light',
        darkMode: 'Dark',
        auto: 'System (auto)',
        pill: 'Pill',
      },
      presets: {
        defaultLight: 'Light — Default',
        darkPro: 'Dark Pro',
        minimal: 'Minimal',
        vibrant: 'Vibrant',
        luxuryGold: 'Package — Luxury Gold',
        summerBreeze: 'Package — Summer Breeze',
        codexpinNight: 'Package — CodexPin Night',
        forest: 'Package — Forest Green',
        ocean: 'Package — Ocean',
        corporate: 'Package — Corporate',
        roseGold: 'Package — Rose Gold',
      },
    cache: {
      title: 'Cache Settings',
      description: 'Manage the automatic refresh interval for storefront pages in seconds.',
      hint: 'Cache is cleared immediately when the theme is published. These intervals are the upper limit for automatic refresh on normal visits. A value of 0 disables the cache for that data.',
      loading: 'Loading cache settings',
      loadError: 'Failed to load cache settings.',
      homeLabel: 'Homepage Cache Duration (s)',
      homeHint: 'Automatic refresh interval for homepage products and theme data.',
      productLabel: 'Product Detail Cache Duration (s)',
      productHint: 'Automatic refresh interval for product detail data.',
      rangeHint: 'Enter a whole number between 0 and 86400.',
      actionsTitle: 'Actions',
      saveBtn: 'Save Settings',
      refreshBtn: 'Refresh Cache',
      savedSuccess: 'Cache settings saved and storefront updated.',
      saveError: 'Failed to save cache settings.',
      refreshed: 'Storefront cache refreshed.',
      refreshFailed: 'Failed to refresh storefront cache.',
    },
    templates: {
      title: 'Page Management',
      description: 'Choose design templates for storefront pages.',
      activeTheme: 'Active theme:',
      previewCategories: 'Preview Categories',
      noTemplates: 'No configurable page templates for this theme.',
      saveAndPublish: 'Save & Publish',
      publishDraft: 'Publish Draft',
      draftLabel: 'Page templates draft',
      published: 'Page templates published.',
    },
    customizer: {
      revisionLoaded: 'Revision loaded to draft',
      revisionFailed: 'Failed to load revision',
      abStarted: 'A/B test started',
      abStopped: 'A/B test stopped',
      abCreated: 'A/B experiment created',
      abUpdated: 'Experiment updated',
      profileCreated: 'Profile created',
      profileFailed: 'Failed to create profile',
      webhookSaved: 'Webhook saved',
      webhookFailed: 'Failed to save webhook',
      tabA11y: 'Accessibility',
      tabSecurity: 'Security',
      tabHistory: 'History',
      tabProfiles: 'Profiles',
      tabAbTest: 'A/B Test',
      tabIntegrations: 'Integrations',
      a11yTitle: 'Contrast Audit',
      a11yPass: 'All contrasts passed',
      a11yFail: '{count} contrast failure(s)',
      a11yWarn: 'Warning',
      securityTitle: 'Theme Validation',
      securityOk: 'Theme settings are valid',
      historyTitle: 'Revision History',
      historyEmpty: 'No revisions yet.',
      historyRestore: 'Load',
      profilesTitle: 'Storefront Profiles',
      profilesSlugLabel: 'Slug',
      profilesNameLabel: 'Display name',
      profilesPatternLabel: 'Host pattern',
      profilesCreate: 'Create profile',
      integrationsWebhook: 'Publish webhook URL (POST — theme.settings.published)',
      integrationsSecret: 'HMAC secret {status}',
      integrationsSecretRegistered: '(registered)',
      integrationsSecretPlaceholder: 'New secret (optional)',
      integrationsSave: 'Save',
      abNotAvailable: 'A/B testing is available on the Enterprise plan.',
      abCreateExp: 'Create experiment',
      abStart: 'Start',
      abStop: 'Stop',
      abUpdate: 'Update',
    
      customCssLocked: 'Custom CSS locked',
      profilesLimit: 'Plan limit: {count} profiles',
      webhookUrlLabel: 'Publish webhook URL (POST · theme.settings.published)',
      webhookSaveBtn: 'Save webhook',
    },
    editor: {
      drag: 'Drag',
      remove: 'Remove',
      navItemLabel: 'Label',
      navDotColor: 'Dot color',
      navSubmenu: 'Submenu',
      navNewItem: 'New item',
      navNoItems: 'No menu items yet.',
      navAddItem: 'Add menu item',
      tickerPlaceholder: 'Campaign text',
      tickerNewItem: 'New campaign text',
      tickerEmpty: 'Add ticker text.',
      tickerAddRow: 'Add row',
      semanticAutoDerive: 'Auto-derive',
      semanticHint: 'Semantic token chains — changing the base color can auto-derive hover and contrast.',
      abBTrafficLabel: 'B traffic %',
      abPreviewA: 'Preview A',
      abPreviewB: 'Preview B',
      abVariantA: 'Variant A (current customizer)',
      abVariantB: 'Variant B',
      abCopyFromA: 'Copy from A',
      selectPlaceholder: 'Select...',
      colorPicker: '{label} color picker',
    },
    },
  },

  widgets: {
    pages: {
      home: 'Home',
      products: 'Products (List)',
      productDetail: 'Product Detail',
      categories: 'Categories',
      categoryDetail: 'Category Detail',
      cart: 'Cart',
      checkout: 'Checkout',
      checkoutSuccess: 'Checkout Success',
      search: 'Search Results',
      blog: 'Blog (List)',
      blogDetail: 'Blog Detail',
      contact: 'Contact',
      about: 'About Us',
      faq: 'FAQ',
      account: 'My Account',
      accountOrders: 'My Orders',
      accountFavorites: 'My Favorites',
      accountProfile: 'My Profile',
      accountAddresses: 'My Addresses',
      accountWallet: 'My Wallet',
      accountTickets: 'Support Tickets',
      login: 'Sign In / Sign Up',
      all: 'All Pages',
    },
    cta: 'BUY NOW',
    guideButton: 'Example',
    guideHide: 'Hide example',
    guideTitle: 'How it looks on the storefront',
    guideSlots: {
      slide: 'Slide',
      badge: 'Badge',
      title: 'Title',
      art: 'Art',
      tab: 'Tab',
      banner: 'Banner',
      product: 'Product',
      category: 'Category',
      logo: 'Logo',
      text: 'Text',
      video: 'Video',
      blog: 'Post',
      publisher: 'Publisher',
      left: 'Left',
      center: 'Center',
      right: 'Right',
      top: 'Top',
      bottom: 'Bottom',
      button: 'Button',
      sidebar: 'List',
      cover: 'Cover',
    },
    guide: {
      slider: 'Each item is one slide. Badge, headline, subtext, and button sit on the image.',
      hero_slider: 'A rotating slide sits in the center, with a banner rail and an optional promo card.',
      carousel: 'Center slides use an image and a title. Left and right banners are separate items.',
      carousel_left: 'Slides fill the left side. The top-right and bottom-right banners stack on the right.',
      cp_hero: 'Each item is one tab. Copy, art panel, and tab logo are drawn together.',
      banner_grid: 'One image is full width, two split the row, three or four form a grid. Four items max.',
      product_grid: 'Chosen products appear as a card grid. Image and price come from the product.',
      full_bg_products: 'Tabs and product cards slide over a full background image.',
      advantage_product: 'Discounted cards slide. Pin products yourself or use the highest-discount filter.',
      popular_product: 'Product cards loop. Pick them yourself or use a popularity filter.',
      category_carousel: 'Categories line up in a horizontal strip with an icon or image.',
      slide_category: 'Category tabs sit on top. The product slider below follows the active tab.',
      horizon_category: 'A banner sits on one side and product cards scroll on the other.',
      horizontal_category: 'A banner stays on the left and products fill a grid on the right.',
      brand_logos: 'Saved brand logos form the strip. You can add your own logos in front.',
      brands_area: 'Saved brand logos scroll. Logos you add stay first.',
      announcement_bar: 'A thin band. A short line, an accent color, and a link are enough.',
      text_block: 'A free text area. The title and HTML content render as a page block.',
      video_banner: 'The video plays in the frame. The cover image shows before playback.',
      blog_section: 'Posts come from the blog. This template has no items; the title is set on the section.',
      publisher: 'Publisher cards slide with an image, a name, and a link.',
      cp_featured: 'Each item is a campaign card. Title, link, and accent color are used.',
      cp_shop: 'A game list sits on the left and a product grid on the right. Products come from the catalog.',
      cp_gift: 'Gift-card platforms appear as colored cards.',
      cp_market: 'Listings appear in a marketplace grid.',
      b2b_cta: 'A single call-to-action band. Title, short text, and a button are enough.',
      default: 'Items land on the storefront in the layout below.',
    },

    // Page title
    pageTitle: 'Widget Management',
    layoutBuilderTitle: 'Layout Builder',
    addLayout: 'Add',
    dragToReorder: 'Drag to reorder',
    loading: 'Loading...',
    layoutsLoadFailed: 'Could not load layouts. Refresh the page.',
    noLayouts: 'No layouts found. Use "+ Add" to get started.',
    selectOrAddLayout: 'Select a layout or add a new one',
    livePreviewHint: 'Live preview and item editing happen here',
    layoutBgUploadHint: 'Select a template first to upload a background.',
    reorderFailed: 'Could not save order',
    itemReorderFailed: 'Could not save item order',
    layoutSaved: 'Layout updated',
    layoutCreated: 'Layout created',
    layoutSaveFailed: 'Could not save',
    layoutDeleted: 'Layout deleted',
    layoutDeleteConfirm: 'Delete this layout?',
    itemSaved: 'Item updated',
    itemCreated: 'Item created',
    itemSaveFailed: 'Could not save',
    itemDeleteConfirm: 'Delete this item?',
    bannerLimitFull: 'Limit reached — maximum {max} banners allowed.',
    bannerLimitFullShort: 'Maximum {max} banners allowed',

    // LayoutCard
    setInactive: 'Deactivate',
    setActive: 'Activate',
    itemCount: '{count} items',
    editLayout: 'Edit',
    deleteLayout: 'Delete',

    // LayoutFormModal
    editSection: 'Edit Section',
    newSection: 'New Section',
    templateLabel: 'Template *',
    templateSelect: '— Select —',
    titleLabel: 'Title',
    subtitleLabel: 'Subtitle',
    descriptionLabel: 'Description',
    tabAlignLabel: 'Tab Alignment',
    tabAlignLeft: 'Align left',
    tabAlignCenter: 'Align center',
    tabAlignHint: 'Determines how category tabs are aligned in the top bar.',
    pageLabel: 'Page',
    transitionLabel: 'Transition Effect',
    transitionSlide: 'Slide (Loop)',
    transitionFade: 'Fade',
    orderLabel: 'Order',
    bgImageLabel: 'Background Image',
    activeLabel: 'Active',
    cancelLabel: 'Cancel',
    savingLabel: 'Saving...',
    saveLabel: 'Save',

    // ImageUpload
    noUrlReturned: 'Server did not return an image URL.',
    uploadFailedGeneric: 'Upload failed.',
    saveLayoutFirstHint: 'Fill in template and title, then save before uploading a background image.',
    itemCreateFailed: 'Could not create item; image upload aborted.',
    imageOnlyError: 'Only image files can be uploaded.',
    fileSizeError: 'File size cannot exceed 5 MB.',
    imageRemoved: 'Image removed.',

    // ItemCard
    productPrefix: 'Product: ',
    categoryPrefix: 'Category: ',
    editItem: 'Edit',
    deleteItem: 'Delete',

    // ItemFormModal & WidgetEditorCanvas inline editor
    editItemTitle: 'Edit Item',
    newItemTitle: 'New Item',
    afterSavePreviewRefresh: 'Preview refreshes after save',
    closeEditor: 'Close',

    // ItemFormFields
    selectProductLabel: 'Select Store Product',
    productAutoFillHint: 'Name, image, price and link come from the store product.',
    popularProductPickHint: 'Add any product. Title, image, price and link are filled for you. The section filter fills the remaining slots.',
    productAutoFilled: 'These fields came from the selected product.',
    productLoading: 'Loading product',
    popularSourceLabel: 'Popularity filter',
    popularSourceHint: 'Products you add stay first. The filter fills the rest, up to 10. Lowest price uses the cheapest marketplace sale price.',
    popularSource: {
      manual: 'Only products I pick',
      bestsellers: 'Best sellers',
      lowest_price: 'Lowest price',
      most_viewed: 'Most viewed',
      newest: 'Newest',
    },
    advantageSourceLabel: 'Advantage filter',
    advantageSourceHint: 'Products you add stay first. The filter fills up to 10 in-stock products whose sale price is below the market price, highest discount first.',
    advantageProductPickHint: 'Pin any product. The filter fills the remaining slots with the highest discounts.',
    advantageSource: {
      manual: 'Only products I pick',
      highest_discount: 'Highest discount',
    },
    brandSourceLabel: 'Brand source',
    brandSourceHint: 'Registered brands are active brands that have a logo. Logos you add stay in front of them.',
    selectBrandLabel: 'Select a saved brand',
    brandPickHint: 'Choosing a brand fills the name, logo and website. You can upload your own image instead.',
    brandSource: {
      registered: 'Saved brands + my logos',
      manual: 'Only logos I add',
    },
    blogItemsUnused: 'Posts come from the blog. This template has no items. Title, subtitle and description are set on the section.',
    selectCategoryLabel: 'Select Store Category',
    selectTabProductsLabel: 'Select Products for This Tab',
    selectCategoryProductsLabel: 'Select Category Products',
    categoryCarouselDesc: 'Each item is a category tab. Selected products are listed only in that category.',
    horizontalCategoryDesc: 'Products shown next to the banner (max {max}, 3×3 grid).',
    bannerCategoryDesc: 'Products shown next to the banner. Each item is a separate storefront block.',
    defaultCategoryDesc: 'Selected products will be listed in the storefront under this category.',
    showCategoryNameLabel: 'Show category name in tab',
    showCategoryNameHint: 'When off, only the category image is shown.',
    bannerPositionLabel: 'Banner Position',
    bannerLeft: 'Banner on left',
    bannerRight: 'Banner on right',
    announcementTextLabel: 'Announcement text',
    announcementPlaceholder: 'e.g. 24/7 automatic delivery active — valid for all e-pins',
    announcementVisuals: 'Announcement appearance (optional)',
    badgeLabel: 'Badge',
    eyebrowLabel: 'Eyebrow',
    ctaButtonLabel: 'Button text',
    colorLabel: 'Accent color',
    contentFieldLabel: 'Content',
    contentPlaceholder: 'Text block content...',
    videoUrlLabel: 'Video URL',
    coverImageLabel: 'Cover Image',
    slideImageLabel: 'Slide Image',
    productImageLabel: 'Product Image',
    categoryImageLabel: 'Category Image',
    brandLogoLabel: 'Brand Logo',
    bannerImageLabel: 'Banner Image',
    videoFallbackHint: 'Shown if video fails to load',
    rightPanelImageLabel: 'Right Panel / Art Image',
    tabLogoLabel: 'Tab Logo',
    headlineLabel: 'Headline',
    subTextLabel: 'Subtext',
    ctaTextLabel: 'CTA Text',
    accentColorLabel: 'Accent Color',
    showArtLabel: 'Show Slide Image',
    showArtHint: 'When off, only gradient background + text is shown',
    carouselItemHint: 'This template uses image, title, link, and position only. Art panel, tab logo, badge, and copy belong to CodexPin Hero Slide.',
    positionLabel: 'Position',
    sliderLeft: 'Left Slider',
    bannerTopRight: 'Top-Right Banner',
    bannerBottomRight: 'Bottom-Right Banner',
    sliderCenter: 'Center Slider',
    bannerLeftLabel: 'Left Banner',
    bannerRightLabel: 'Right Banner',
    priceLabel: 'Price (TRY)',
    cancelBtn: 'Cancel',
    savingBtn: 'Saving...',
    addBtn: 'Add',
    updateBtn: 'Update',

    // WidgetEditorCanvas specific
    itemsTitle: 'Items',
    clickToEdit: 'click a card to edit',
    desktopTitle: 'Desktop',
    mobileTitle: 'Mobile',
    fitToScreen: 'Fit layout to screen',
    fitToWidth: 'Fit to width (scroll vertically)',
    refreshPreview: 'Refresh preview',
    openInNewTab: 'Open in new tab',
    editSection2: 'Layout',
    addItem: 'Item',
    deleteItemAria: 'Delete item',
    itemAria: 'Item: {title}',
    noItemsYet: 'No items yet — use "Add Item" to get started',
    leftSlider: 'Left slider · drag',
    leftSliderNoItems: 'No slider items',
    rightTopBottom: 'Right (top/bottom)',
    topBannerEmpty: 'No top banner',
    bottomBannerEmpty: 'No bottom banner',
    leftBannerEmpty: 'No left banner',
    rightBannerEmpty: 'No right banner',
    centerSlider: 'Center slider · drag',
    leftLabel: 'Left',
    rightLabel: 'Right',
    bannerLimitNote: 'Banner limit reached ({count}/{max})',

    // WidgetPreviewFrame
    previewLoading: 'Loading preview…',
    previewFailed: 'Preview could not be opened',
    openInNewTabLink: 'Open in new tab',
    fitLayout: 'Full layout fitted',
    fitWidth: 'Fit to width',
    previewIframeTitle: 'Widget live preview',

    // SimpleSelects
    categorySearch: 'Search category...',

    // ImageUpload inline labels
    uploadClickOrDrag: 'Click or drag',
    uploadFormatHint: 'JPG, PNG, WebP — max 5 MB',
    uploadChanging: 'Change',
    uploadRemoveBtn: 'Remove image',

    // ItemFormFields
    templatePrefix: 'Template:',
    topBarLabel: 'Top Bar Text',
    rightBannerOption: 'Right Banner',
    layoutMissingErr: 'No layout selected',
  },

  shared: {
    comingSoon: {
      badge: 'Coming Soon',
      defaultDescription: 'This section has not been developed yet. It will be active soon.',
    },
    placeholder: {
      apiNote: 'This section will be connected to an API soon.',
    },
  },

  faq: {
    title: 'FAQ Management',
    subtitle: 'Manage frequently asked questions — listed at /faq in the storefront',
    addQuestion: 'Add Question',
    searchPlaceholder: 'Search questions...',
    emptyTitle: 'No FAQ entries yet',
    emptyDesc: 'Add questions your customers frequently ask.',
    addFirst: 'Add first question',
    colTitle: 'Title',
    colOrder: 'Order',
    colStatus: 'Status',
    colUpdated: 'Updated',
    published: 'Published',
    hidden: 'Hidden',
    editModal: 'Edit FAQ',
    newModal: 'New FAQ',
    questionLabel: 'Question *',
    iconLabel: 'Icon (optional)',
    answerLabel: 'Answer *',
    orderLabel: 'Order',
    deleteConfirm: 'Delete this question?',
    savingLabel: 'Saving…',
    updateLabel: 'Update',
  },

  pages: {
    title: 'Page Management',
    subtitle: 'Static pages such as GDPR, About Us, and Privacy Policy',
    addPage: '+ Add Page',
    colTitle: 'Title',
    colSlug: 'Slug',
    colOrder: 'Order',
    colStatus: 'Status',
    colUpdated: 'Updated',
    published: 'Published',
    hidden: 'Hidden',
    editModal: 'Edit Page',
    newModal: 'New Page',
    titleLabel: 'Title *',
    iconLabel: 'Icon (optional)',
    contentLabel: 'Content *',
    contentPlaceholder: 'Write page content...',
    orderLabel: 'Order',
    deleteConfirm: 'Delete this page?',
    emptyPage: 'No pages added yet.',
    storefrontNote: 'Pages are accessible at /pages/[slug] in the storefront.',
    savingLabel: 'Saving…',
    updateLabel: 'Update',
  },

  menus: {
    title: 'Menu Management',
    subtitle: 'For dropdown menus, first create a parent link with the "Dropdown menu" option, then add sub-links.',
    addLink: '+ Add Link',
    posTop: 'Top Menu',
    posFooter: 'Footer',
    posMobile: 'Mobile Menu',
    emptyTitle: 'No links in this position yet',
    emptyDesc: 'Use the button above to add a new link.',
    colOrder: 'Order',
    colTitle: 'Title',
    colUrl: 'URL',
    colStatus: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    addChildLink: '+ Sub Link',
    editModal: 'Edit Link',
    addChildModal: 'Add Sub Link',
    newModal: 'New Link',
    parentLink: 'Parent Link (dropdown)',
    noParent: '— None (root link) —',
    parentLinkHint: 'Select a parent link if this link should appear under a dropdown',
    positionLabel: 'Position *',
    titleLabel: 'Title *',
    urlLabel: 'URL',
    iconLabel: 'Icon (CSS class)',
    orderLabel: 'Order',
    dropdown: 'Dropdown menu',
    deleteConfirm: 'Delete {title}{hasChildren}?',
    deleteWithChildren: ' and all sub-links',
    savingLabel: 'Saving...',
    loadingLabel: 'Loading...',
  },

  templates: {
    title: 'Email & Notification Templates',
    subtitle: 'Edit templates for orders, invoices, and system notifications.',
    tabEmail: 'Email templates',
    tabSms: 'SMS / WhatsApp',
    tabAddresses: 'Email addresses',
    newTemplate: 'New template',
    emailSaved: 'Email template saved',
    notifSaved: 'Notification template saved',
    saveFailed: 'Save failed',
    deleted: 'Deleted',
    deleteConfirm: 'Delete this?',
    colKey: 'Key',
    colSubject: 'Subject',
    colStatus: 'Status',
    colChannel: 'Channel',
    colLocale: 'Language',
    active: 'Active',
    inactive: 'Inactive',
    editEmailModal: 'Edit email template',
    newEmailModal: 'New email template',
    editNotifModal: 'Edit notification template',
    newNotifModal: 'New notification template',
    keyLabel: 'Key (name)',
    subjectLabel: 'Subject',
    contentLabel: 'Content',
    messageLabel: 'Message',
    channelLabel: 'Channel',
  },

  content: {
    translations: {
    table: 'Table',
    json: 'JSON',
    allFields: 'All fields',
    fieldSet: 'Field set',
    longHtml: 'long HTML',
    scopeAlert: 'Scope: {note}. To translate the full catalog, use search/filter + paginate, or merge single-language JSONs and save.',
    loadingTranslations: 'Loading translations… ({count} records)',
    noJsonRecords: 'No records in this scope for JSON. Broaden the filter or add records in the table.',
    heavyWarning: 'This set contains long HTML. Be mindful of size when sending to AI; use the title/short field set if needed.',
    importSuccess: '{entities} records · {fields} fields updated',
    jsonSaveFailed: 'JSON save failed',
    importEmpty: 'Nothing to import',
    hint: 'Bulk translate: copy → AI → paste → save.',
    copySuccess: '{lang} JSON copied to clipboard',
    copyAllSuccess: 'Full catalog JSON copied',
    copyFailed: 'Copy failed',
    defaultHint: 'Copy JSON → translate with AI → paste → save. For a flat single-language object, use the target language selector.',
    copyLocale: 'Copy {lang}',
    copyAll: 'Copy all',
    saveJson: 'Save JSON',
    jsonAriaLabel: 'Translation JSON editor',
    targetLang: 'Target / copy language',
    jsonHint: 'Copy JSON → translate with AI → paste → save. For single-locale flat objects, use the locale selector.',
    jsonEditorAria: 'Translation JSON editor',
  },
  },
}
